/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Production
 */
export interface Production {
    /**
     * 
     * @type {number}
     * @memberof Production
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof Production
     */
    readonly isSpecial: boolean;
    /**
     * 
     * @type {number}
     * @memberof Production
     */
    readonly specialType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Production
     */
    readonly totalSize: number | null;
    /**
     * 
     * @type {string}
     * @memberof Production
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Production
     */
    obscureName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Production
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Production
     */
    longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Production
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Production
     */
    template?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Production
     */
    defaultGroup?: number | null;
}

export function ProductionFromJSON(json: any): Production {
    return ProductionFromJSONTyped(json, false);
}

export function ProductionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Production {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isSpecial': json['is_special'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
        'totalSize': json['total_size'],
        'name': json['name'],
        'obscureName': !exists(json, 'obscure_name') ? undefined : json['obscure_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'defaultGroup': !exists(json, 'default_group') ? undefined : json['default_group'],
    };
}

export function ProductionToJSON(value?: Production | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'obscure_name': value.obscureName,
        'description': value.description,
        'long_description': value.longDescription,
        'active': value.active,
        'template': value.template,
        'default_group': value.defaultGroup,
    };
}


